import { useEffect, useState } from 'react';
import usePollsLeftMap from './usePollsLeftMap';

// Types
import { IBasstrakkCatch, PollsLeftMap } from '../types';

// Util
import * as api from '../util/api';
import { refreshRate } from '../util/util';

const CATCHES_FETCH_RATE = refreshRate([5000, 5000]);

const useAnglerCatches = (tid: number, daydate: string) => {
  const [catches, setCatches] = useState<IBasstrakkCatch[]>([]);
  const [pollsLeftMap, setPollsLeftMap] = usePollsLeftMap();

  const setPollsLeft = (keptCatches: IBasstrakkCatch[]) => {
    keptCatches.forEach((catchItem) => {
      const {
        uid = '',
        Time,
      } = catchItem;
      // If we don't have a uid or time, return.
      if (!uid || !Time) {
        return;
      }
      // If time was more than 5 minutes ago, remove from map and return.
      if (Date.parse(Time) + 300000 < new Date().getTime()) {
        pollsLeftMap.delete(uid);
        return;
      }
      // If we don't have a uid in the map, set it to 30.
      // Otherwise, decrement the value by 1.
      if (!pollsLeftMap.has(uid)) {
        pollsLeftMap.set(uid, 30);
      } else {
        pollsLeftMap.set(uid, pollsLeftMap.get(uid) - 1);
      }
    });
  }

  useEffect(() => {
    const catchesApi = `/wp-json/data/v1/tournament/basstrakk/catches?tournament_id=${tid}&daydate=${daydate}`;

    /**
     * Set state for catches when api returns.
     * NOTE: *returns a function to capture scope*
     */
    const storeCatches = () => (response: IBasstrakkCatch[]) => {
      if (response) {
        // We never render catches that aren't kept so it easier if we just remove
        // them now before rendering any components
        const keptCatches = response.filter(({ IsKept }) => IsKept === 'Y');
        setPollsLeft(keptCatches)
        setCatches(keptCatches);
      }
    };

    (async () => {
      await api.subscribe({
        callback: storeCatches(),
        rate: CATCHES_FETCH_RATE,
        uri: catchesApi,
      });
    })();
  }, [tid, daydate]);

  return catches;
};

export default useAnglerCatches;
